import React, { useState, useEffect } from 'react';
import { Redirect, /*Link*/ } from 'react-router-dom';

import { reqGET } from '../../../Utils';
import { api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

export default function View(props) {

    const [/*dados*/, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />

            :
            
            <main>
                
            </main>
}